import os from 'os';
import { AsyncSeriesHook } from 'tapable';
import type { UnsetAdditionalOptions } from 'tapable';
import type { Express } from 'express';
import chalk from 'chalk';

export function getNetworkAddress() {
  for (const [, interfaces] of Object.entries(os.networkInterfaces())) {
    if (!interfaces) {
      continue;
    }
    for (const network of interfaces) {
      const { address, family, internal } = network;
      if (family === 'IPv4' && !internal) {
        return address;
      }
    }
  }
}

export function getNetworkAddressLog({ host = 'localhost', port }: { host?: string; port: number }) {
  const ip = getNetworkAddress();
  const localAddress = `http://${host}:${port}`;
  const networkAddress = `http://${ip}:${port}`;
  return [
    `${chalk.bold(`- Local Address:   `)}${localAddress}`,
    `${chalk.bold(`- On Your Network: `)}${networkAddress}`,
  ];
}

export function createServerHooks(): ServerHooks {
  return {
    beforeInitialize: new AsyncSeriesHook<[Express]>(['app']),
    afterInitialize: new AsyncSeriesHook<[Express]>(['app']),
  };
}

export type ServerHooks = {
  beforeInitialize: AsyncSeriesHook<[Express], UnsetAdditionalOptions>;
  afterInitialize: AsyncSeriesHook<[Express], UnsetAdditionalOptions>;
};
